<template>
    <swiper-container class="branches-swiper"
      :pagination="false"
      :grab-cursor="true"
      :loop="false"
      :navigation="false"
      :space-between="24"
      :follow-finger="true"
      :short-swipes="false"
      :slides-per-view="'auto'"
    >
        <slot />
    </swiper-container>
</template>

<script>
import { register } from 'swiper/element';

register();

export default {
  name: 'BranchesMapSliderComponent',
};
</script>

<style lang="scss">
  .branches-swiper {
    width: 100%;
  }

  swiper-container.branches-swiper::part(container) {
    overflow: visible !important;
  }

  swiper-container.branches-swiper::part(wrapper) {
    align-items: flex-start;
  }

  .branches-swiper__slide {
    width: 300px;
    min-height: 400px;
    display: flex !important;
    flex-direction: column !important;
    align-self: flex-start;

    .contact__location {
      flex-grow: 1;
    }

  }
</style>
